import { render, staticRenderFns } from "./ServiceFormTemplate.vue?vue&type=template&id=20f4d94c"
import script from "./ServiceFormTemplate.vue?vue&type=script&lang=js"
export * from "./ServiceFormTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports